// src/stone/icons/HandMoney.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandMoney = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 29",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M17.5 2.175a4.833 4.833 0 1 0 0 9.667 4.833 4.833 0 0 0 0-9.667M10.665 7.01a6.833 6.833 0 1 1 13.667 0 6.833 6.833 0 0 1-13.667 0M.166 13.009h2.167c.743 0 1.983.142 3.22.529 1.057.33 2.253.883 3.09 1.804h3.023a5.667 5.667 0 0 1 5.667 5.667v1h-9v-2h6.86a3.666 3.666 0 0 0-3.527-2.667h-4.02l-.3-.426c-.447-.64-1.326-1.137-2.39-1.47-1.039-.324-2.077-.437-2.623-.437h-.167v6.548l7.109 3.554a3.67 3.67 0 0 0 2.718.226l12.401-3.816-.045-.136a2.5 2.5 0 0 0-2.372-1.71h-3.144v-2h3.144a4.5 4.5 0 0 1 4.269 3.077l.692 2.078-14.357 4.418a5.67 5.67 0 0 1-4.2-.348L.165 22.794z" }),
      /* @__PURE__ */ jsx("path", { d: "M18.5 4.842v4.333h-2V4.842z" })
    ]
  }
);
var HandMoney_default = HandMoney;

export {
  HandMoney_default
};
